import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useAuth0 } from "react-auth0-spa";
import {
  BenefitsSummaryResponse,
  fetchBenefitsSummary,
} from "./benefitsSummary.api";

export type BenefitsSummaryState =
  | { status: "loading" }
  | { status: "error" }
  | { status: "success"; data: BenefitsSummaryResponse };

export function useBenefitsSummary() {
  const { getTokenSilently } = useAuth0();
  const [state, setState] = useState<BenefitsSummaryState>({ status: "loading" });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    setState({ status: "loading" });

    (async () => {
      try {
        const token = await getTokenSilently();
        const data = await fetchBenefitsSummary(token, controller.signal);
        if (!controller.signal.aborted) setState({ status: "success", data });
      } catch (error) {
        if (controller.signal.aborted || axios.isCancel(error)) return;
        setState({ status: "error" });
      }
    })();

    return () => controller.abort();
    // getTokenSilently is not stable across renders in react-auth0-spa.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attempt]);

  const retry = useCallback(() => setAttempt((count) => count + 1), []);

  return { state, retry };
}
